export default __webpack_public_path__ + "static/media/MathsTonic.21bc4e4c1b41ef6bfdc7b11a172c3d34.webp";